import {pageInfo, initPage, queryBillDetail, submitData, getExportData, billDetailExport} from './../api';
import { Message } from 'element-ui';
const bill = {
  namespaced: true,
  state: {
    successCode: 200,
    total:0,
    pageResp:null,
    initPageObj: null,
    billDetailObj: null,
    submitResp: null,
    exportObj: null,
    detailExportObj: null
  },
  mutations: {

    PAGE_INFO(state,data){
      state.pageResp = (data.obj || []).map(item => ({
        ...item
      }));
      state.total = data.total;
    },
    INIT_PAGE(state,data) {
      state.initPageObj = data.obj || {};
    },
    BILL_DETAIL(state,data) {
      state.billDetailObj = data.obj;
    },
    SUBMIT_DATA(state,data) {
      state.submitResp = data;
    },
    EXPORT_DATA(state,data) {
      state.exportObj = data;
    },
    BILL_DETAIL_EXPORT(state, data){
      state.detailExportObj = data;
    }
  },
  actions: {
    //查询事件
    async pageInfo({commit}, obj){
      let resp = await pageInfo(obj);
      commit('PAGE_INFO', resp);
    },
    //初始化页面事件
    async initPage({commit}, obj){
      let resp = await initPage(obj);
      commit('INIT_PAGE', resp);
    },
    //详情
    async queryBillDetail({commit}, obj){
      let resp = await queryBillDetail(obj);
      commit('BILL_DETAIL', resp);
    },
    //修改
    async submitData({commit}, obj){
      let resp = await submitData(obj);
      commit('SUBMIT_DATA', resp);
    },
    //导出
    async getExportData({commit}, obj){
      let resp = await getExportData(obj);
      commit('EXPORT_DATA', resp);
    },
    //对账信息详情导出
    async billDetailExport({commit}, obj){
      let resp = await billDetailExport(obj);
      commit('BILL_DETAIL_EXPORT', resp);
    }
  }
}
export default bill



// WEBPACK FOOTER //
// ./src/page/finance/invoice/store/invoice.store.js